import { Router } from "./routes/Router.component";

function App() {
  return <Router />;
}

export default App;
